export default __webpack_public_path__ + "static/footer-1-0ae076815f77e4f72c4cd2c945855ed8.jpg";